import { useState, useEffect } from 'react';

import { useRouteMatch } from 'react-router-dom';

/**
 * Given a URL that might have slugs separated by double dashes, parse the URL into slugs.
 *
 * @param {String} pathname  - full URL
 */
export const findSlugsInPath = (pathname = ''): string[] => {
  return pathname // /inspiration/real-weddings/boho--new-york-ny
    .split('--') // split out into facet / color / location slugs, [boho, new-york-ny]
    .filter((p) => p !== ''); // cleanup! (would remove a trailing --, ie boho-- becomes [boho] instead of [boho, ])
};

/**
 * A custom hook that parses the current location into slugs.  Re-parses
 * when the current location changes.
 *
 * @example
 *   current url: /inspiration/real-weddings/new-york-ny--cats--dogs--goldfish--favorite-animals
 *   path: /inspiration/real-weddings
 *   parsed slugs: [new-york-ny, cats, dogs, goldfish, favorite-animals]
 *
 * @param {*} props
 * @param {*} props.prefix - the URL prefix to ignore in parsing
 *
 */
const usePathSlugs = (): string[] => {
  const { params } = useRouteMatch<{ slug?: string }>();

  const [pathSlugs, setPathSlugs] = useState<string[]>(findSlugsInPath(params.slug));

  // location.pathname - match gives us parts of the URL that come
  // from facets or other parameters (locations?)
  useEffect(() => {
    const newPathSlugs = findSlugsInPath(params.slug);

    // The current URL starts with the same thing as we put in the route
    // anything _after- that in the path, should be treated as a filter
    setPathSlugs(newPathSlugs);
  }, [params.slug]);

  return pathSlugs;
};

export default usePathSlugs;
